import {
    ApiBaseService,
    type PaginatedFetch,
    type PaginatedFetchOptions,
} from "./ApiBaseService";
import type { Message } from "~/models/Chat";
import type { ApiResponse } from "~/types/ApiResponse";
import type { ExtendedDropdownItem } from "~/components/ui/DropdownItems.vue";

export default class MessageService extends ApiBaseService {
    public list(
        options?: Partial<PaginatedFetchOptions>,
    ): PaginatedFetch<Message> {
        return this.paginate<Message>(
            this.route("api.messages.index", "/messages"),
            options as PaginatedFetchOptions,
        );
    }

    public listRoute() {
        return this.route("api.messages.index", "/messages");
    }

    public find(id: string): Promise<ApiResponse<Message>> {
        return this.request(
            this.route("api.messages.show", "/messages/{id}", {
                id,
            }),
        );
    }

    public dropdown(
        // todo: add dropdown options with actions
        // message: Message | Ref<Message>,
        // options: Partial<{
        //     isEditing?: boolean;
        //     deletable?: Ref<Message | undefined>;
        //     onWithdrawal?: () => void;
        //     onPublish?: () => void;
        //     onArchive?: () => void;
        // }> = {},
    ): Partial<ExtendedDropdownItem>[][] {
        return [];
    }
}
